<template>
  <d-modal
    class="crm-new-popup institution-prices"
    v-if="showModal"
    @close="closeModal"
    style="background-color: rgba(0,0,0,0.6)!important;">
    <d-modal-header>
      <d-modal-title>
        <h3 class="page-title">
          Cennik produktów
        </h3>
      </d-modal-title>
    </d-modal-header>
    <d-modal-body>
      <div
        class="spinner-load"
        v-if="!templateListLoad">
        <div
          class="spinner-border spinner-border-sm crm-new-popup-spinner"
          role="status"></div>
      </div>

      <product-price-table
        v-if="templateListLoad"
        ref="priceTable"
        :all-products="allProducts"
        :show-load-button="true"
        :show-heading="false"
        @load-prices="showLoadPricesModal = true" />

      <div
        v-if="!allProducts"
        class="pb-3 pt-3 text-center">
        Trwa ładowanie danych&hellip;
      </div>

      <d-alert
        v-if="loadError"
        show
        theme="warning">
        Wczytywanie danych nie powiodło się. <a
          href="javascript:window.location.reload();"
        class="alert-link">Odśwież stronę</a> aby spróbować ponownie.
      </d-alert>

      <div class="popup-box-buttons">
        <d-button
          :theme="'success'"
          class="text-nowrap"
          @click.prevent="submitProductsPrice">
          Zapisz cennik
        </d-button>
        <d-button
          theme="secondary"
          class="text-nowrap ml-3"
          @click.prevent="closeModal">
          Zamknij
        </d-button>
      </div>

      <load-prices-modal
        v-if="shopId"
        :show-modal="showLoadPricesModal"
        :close-modal="closeLoadPricesModal"
        :entity-id="shopId"
        entity-type="SHOP"
        load-endpoint="/customers/shops/load-prices/"
        @prices-loaded="onShopPricesLoaded" />
    </d-modal-body>
  </d-modal>
</template>

<script>
import FormUtils from '@/utils/FormUtils.js';
import LoadPricesModal from '../priceLists/LoadPricesModal.vue';
import ProductPriceTable from '@/components/common/ProductPriceTable.vue';

export default {
  name: 'customers-form-institution-prices',
  components: {
    LoadPricesModal,
    ProductPriceTable
  },
  data () {
    return {
      data: {
        products: [],
        prices: []
      },
      templateListLoad: false,
      allProducts: [],
      loaded: false,
      loadError: false,
      showLoadPricesModal: false
    };
  },
  props: {
    showModal: {
      type: Boolean,
      required: true
    },
    closeModal: {
      type: Function,
      required: true
    },
    refresh: {
      type: Function,
      required: true
    },
    shopId: {
      type: [String, Number],
      required: true
    }
  },
  mounted () {
    this.templateListLoad = false;
    if (this.isEdit) {
      this.getProducts();
    }
  },
  watch: {
    'data.products': function () {
      this.trySetPrices();
    },
    'allProducts': function () {
      this.trySetPrices();
    },
    'showModal': function (value) {
      if (value === true) {
        setTimeout(() => {
          if (!this.data.products.length) {
            this.templateListLoad = true;
          }
        }, 1000);
      }
    },
    'shopId': function () {
      this.getProducts();
      this.loadItemData();
    }
  },
  methods: {
    trySetPrices () {
      if (!this.data.products.length || !this.allProducts.length || !this.isEdit) {
        return;
      }
      let normalized = this.data.products.map(item => ({
        id: item.pivot ? item.pivot.product_id : item.id,
        price: item.pivot ? Number(item.pivot.price) : Number(item.price)
      }));
      this.templateListLoad = true;
      this.$nextTick(() => {
        this.$refs.priceTable.setPrices(normalized);
      });
    },
    getProducts () {
      FormUtils.loadAdditionalData(this, {
        endpoint: '/products/items',
        outputKey: 'allProducts',
        params: {
          pagination: false
        }
      });
    },
    loadItemData () {
      FormUtils.loadItemData(this, {
        id: this.shopId,
        endpointBase: '/customers/shops/item/',
        instanceFields: ['products', 'prices'],
        loadedKey: 'loaded'
      });
    },
    submitProductsPrice () {
      let formDataToSend = {
        prices: this.$refs.priceTable.getPricedProducts()
      };
      let endpointUrl = '/customers/shops/store-prices/' + this.shopId;

      FormUtils.submit(this, {
        endpoint: endpointUrl,
        formData: formDataToSend,
        successTitle: 'Zapisano ceny',
        successText: 'Wybrane ceny zostały zapisane',
        errorTitle: 'Wystąpił błąd',
        errorText: 'Modyfikacja cen nie powiodła się. Spróbuj ponownie.',
        successAction: () => {
          this.refresh();
        }
      });
    },
    closeLoadPricesModal () {
      this.showLoadPricesModal = false;
    },
    onShopPricesLoaded (prices) {
      this.showLoadPricesModal = false;
      this.$refs.priceTable.setPrices(prices);
    }
  },
  computed: {
    allDataLoaded () {
      return this.loaded;
    },
    isEdit () {
      return !!this.data.prices.length;
    }
  }
};
</script>

<style lang="scss">
.institution-prices {
  .modal-dialog {
    max-width: none;
    width: 50%;
    .modal-content {
      .modal-body {
        overflow: auto;
        max-height: 760px;
      }
    }
  }
  .vs__dropdown-menu {
    margin-top: -3rem;
    border: 1px solid rgba(black, 0.1);
    overflow: auto;
    max-height: 10rem;
    .vs__dropdown-option--highlight {
      background: var(--theme-color);
    }
  }
}
</style>
